import S from './NewsPageHeroImageLayers.module.scss'

const NewsPageHeroImageLayers = () => {
  return (
    <>
      <div className={S.darken} aria-hidden />
      <div className={S.grainNoise} aria-hidden />
      <div className={S.bottomBlend} aria-hidden />
    </>
  )
}

export default NewsPageHeroImageLayers
